module.exports = require("swiper/react");